import { Injectable } from  '@angular/core';
import { HttpClient, HttpHeaders } from  '@angular/common/http';
import { Globals } from 'projects/shared/models/Globals';

@Injectable({
providedIn:  'root'
})

export  class  MainPortalService {
       
    // public mediaItemURL: SafeUrl;  
    public item: any;
    public items: any[];

    constructor(private  httpClient:  HttpClient) {
    }
  
    getPeriods(){
        return this.httpClient.get(`${Globals.BaseUrl}/InnersWebAPI/GetPeriods`, {
            headers: new HttpHeaders().set('culture', Globals.Culture)
          });
    }

    getDynasties(input){
        return this.httpClient.post(`${Globals.BaseUrl}/InnersWebAPI/GetDynastiesByPeriodId`, input, {
            headers: new HttpHeaders().set('culture', Globals.Culture)
          });
    }
    
    getAntiquities(input){
        return this.httpClient.post(`${Globals.BaseUrl}/InnersWebAPI/GetAntiquitiesByMuseumId`, input, {
            headers: new HttpHeaders().set('culture', Globals.Culture)
          });
    }

    getMonuments(input){
        return this.httpClient.post(`${Globals.BaseUrl}/InnersWebAPI/GetMonumnetByArcSiteId`, input, {
            headers: new HttpHeaders().set('culture', Globals.Culture)
          });
    }

    getMediaItems(input){
        return this.httpClient.post(`${Globals.BaseUrl}/MediaWebAPI/GetMediaInnerComponentItems`, input, {
            headers: new HttpHeaders().set('culture', Globals.Culture)
          });
    }

    getMediaGallery(input){
        return this.httpClient.post(`${Globals.BaseUrl}/MediaWebAPI/GetMediaGallery`, input, {
            headers: new HttpHeaders().set('culture', Globals.Culture)
          });
    }

    getRelatedContent(input){
        return this.httpClient.post(`${Globals.BaseUrl}/RelatedContentWebAPI/GetRelatedContentById`, input, {
            headers: new HttpHeaders().set('culture', Globals.Culture)
          });
    }

    getServices(input){
        return this.httpClient.post(`${Globals.BaseUrl}/ServicesWebAPI/GetServices`, input, {
            headers: new HttpHeaders().set('culture', Globals.Culture)
          });
    }

    getSearchResult(input){
        return this.httpClient.post(`${Globals.BaseUrl}/SearchResultWebAPI/GetSearchResult`, input, {
            headers: new HttpHeaders().set('culture', Globals.Culture)
          });
    }

    getMemberInterestItems(input){
        return this.httpClient.post(`${Globals.BaseUrl}/MembershipWebAPI/GetMemberInterestItems`, input, {
            headers: new HttpHeaders().set('culture', Globals.Culture)
          });
    }

    getRelatedLinks(input){
        return this.httpClient.post(`${Globals.BaseUrl}/RelatedLinksWebAPI/GetRelatedLinks`, input, {
            headers: new HttpHeaders().set('culture', Globals.Culture)
          });
    }

    GetContentRelatedProducts(input){
        return this.httpClient.post(`${Globals.BaseUrl}/EshopWebAPI/GetContentRelatedProducts`, input, {
            headers: new HttpHeaders().set('culture', Globals.Culture)
          });
    }
}